import { render, staticRenderFns } from "./LiveWidget.vue?vue&type=template&id=157afefe"
import script from "./LiveWidget.vue?vue&type=script&lang=js"
export * from "./LiveWidget.vue?vue&type=script&lang=js"
import style0 from "./LiveWidget.vue?vue&type=style&index=0&id=157afefe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports